import { Dispatcher } from "flux";
const dispatcher = new Dispatcher();
export default dispatcher;

// this dispatcher will hold the list of call backs
